import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import "./CreatePlaylist.scss";
import { FiCamera } from "react-icons/fi";
import { createNewPlaylist } from "../../store/playList/actions";
import Swal from "sweetalert2";

const CreatePlaylist = (props) => {
  const [state, setState] = useState({
    title: "",
    description: "",
    price: "",
    duration: "",
    banner: "",
    loading: false
  });
  const [banner, setBanner] = useState(null);

  const handleChange = (event) => {
    let { value, name } = event.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const { createNewPlaylist } = props;
      let formData = new FormData();
      formData.append("title", state.title);
      formData.append("description", state.description);
      formData.append("price", state.price);
      formData.append("duration", state.duration);
      formData.append("banner", banner);
      await createNewPlaylist(formData);
      Swal.fire("Playlist created successfully", "", "success").then(()=>{
        props.history.push("/courses")
      })
    } catch (error) {
      Swal.fire("Something went wrong", "", "error");
    }
  };
  return (
    <div className="Profile container ">
      <h1 className=" font-weight-bold text-black-50 mb-5 pb-3 border-bottom w-100 text-left">
        Create Playlist
      </h1>
      <div className="card shadow ">
        <form action="" onSubmit={handleSubmit}>
          <div className="row top h-100 ">
            <div className="col-12 col-md-12">
              <div className="input-wrapper">
                <div className="input-top">
                  <label htmlFor="" className="input-top-label">
                    Title*
                  </label>
                </div>
                <input
                  type="text"
                  className="input form-control"
                  placeholder="e.g. Learn guitar in a week"
                  required
                  name="title"
                  value={state.title}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="input-wrapper">
                <div className="input-top">
                  <label htmlFor="" className="input-top-label">
                    Description
                  </label>
                </div>
                <textarea
                  name="description"
                  id=""
                  value={state.description}
                  onChange={(e) => handleChange(e)}
                  className="input form-control"
                  placeholder="This is one of the best guitar course out there!"
                  style={{ height: 100 }}
                ></textarea>
              </div>
              <div className="input-wrapper">
                <div className="input-top">
                  <label htmlFor="" className="input-top-label">
                    Price*
                  </label>
                </div>
                <input
                  type="number"
                  className="input form-control"
                  placeholder="e.g. $100"
                  required
                  name="price"
                  value={state.price}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="input-wrapper">
                <div className="input-top">
                  <label htmlFor="" className="input-top-label">
                    Total Duration in hours*
                  </label>
                </div>
                <input
                  type="number"
                  className="input form-control"
                  placeholder="e.g. 8"
                  name="duration"
                  required
                  value={state.duration}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="input-wrapper">
                <div className="input-top">
                  <label htmlFor="" className="input-top-label">
                    Banner*
                  </label>
                </div>
                <input
                  type="file"
                  className="input form-control"
                  required
                  name="banner"
                  onChange={(e) => {
                    setBanner(e.target.files[0]);
                    setState({
                      ...state,
                      banner: URL.createObjectURL(e.target.files[0]),
                    });
                  }}
                />
              </div>
              {state.banner && (
                <div className="input-wrapper d-flex">
                  <img src={state.banner} alt="" style={{ height: 200 }} />
                </div>
              )}
              <div className="input-wrapper d-flex">
                <button className="btn" type="submit" disabled={state.loading}>
                  {state.loading ? "..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps, {
  createNewPlaylist
})(CreatePlaylist);
